<template>
  <div />
</template>

<script>
export default {
  name: 'ProcessOrderWrapper'
}
</script>
